export const EVENT_STYLES = {
  TIMESLOT: 'TimeSlot',
  RSVP: 'RSVP'
};